import Vue from 'vue';
import { intersection } from 'lodash';
import Member from '../Domains/Member/Member';

/**
 * Tests what the current user can do
 *
 * @param member       Member      Member object
 * @param permissions string|array One or more permissions to test
 * @param testType    string       The kind of test to apply if permissions is an array.
 *                                 Can be either "and" or "or".
 *
 * @returns {boolean}
 */
export function can(member: Member, permissions: string | string[], testType : 'and'|'or' = 'and'): boolean {
  const permissionArray = Array.isArray(permissions) ? permissions : [permissions];

  const userPermissions = member!.roles!.permission_names as string[];

  if (testType === 'and') {
    return !permissionArray.some((permission) => !userPermissions.includes(permission));
  }

  return permissionArray.some((permission) => userPermissions.includes(permission))
}

// @ts-ignore
if (!process.env.NO_GLOBAL_USER_MIXIN && !Vue.__permission_service_mixin___) {
  // @ts-ignore
  Vue.__permission_service_mixin___ = true;
  Vue.mixin({
    computed: {
      $user() {
        try {
          // @ts-ignore
          return this.$store.getters['members/me'];
        } catch (e) {
          return false;
        }
      },
    },
  });
}

// @ts-ignore
export default function(ctx) {
  Object.defineProperty(ctx, 'user', {
    get() {
      try {
        // @ts-ignore
        return ctx.store.getters['members/me'];
      } catch (e) {
        return false;
      }
    },
  });
}
